var map = {
	"./components/banner.stories.js": "jROb",
	"./components/box.stories.js": "qxsd",
	"./components/collapsible.stories.js": "scQV",
	"./components/header.stories.js": "B61U",
	"./components/toast.stories.js": "tQNQ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sOjo";